import { Tooltip } from '@mui/material'
import React, { ReactElement } from 'react'
import { dynamicClassName } from 'styles/helper'
import styles from './NewCheckbox.module.less'

type BaseCheckboxProps = {
  checked?: boolean
  disabled?: boolean
  tooltip?: {
    title: string
    placement?: 'top' | 'bottom' | 'left' | 'right'
  }
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
}

type CheckboxWithLabel = BaseCheckboxProps & {
  onlyCheckbox?: false
  label: string
}

type CheckboxWithoutLabel = BaseCheckboxProps & {
  onlyCheckbox: true
  label?: string
}

export type NewCheckboxProps = CheckboxWithLabel | CheckboxWithoutLabel

export default function NewCheckbox({
  label,
  onlyCheckbox = false,
  checked,
  disabled,
  tooltip,
  onChange,
}: NewCheckboxProps): ReactElement {
  const checkboxId = React.useId()

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!disabled) {
      onChange?.(event)
    }
  }

  if (onlyCheckbox) {
    return (
      <Tooltip arrow title={tooltip?.title} placement={tooltip?.placement}>
        <div className={styles.Checkbox_OnlyCheckbox}>
          <input type="checkbox" id={checkboxId} checked={checked} disabled={disabled} onChange={handleChange} />
        </div>
      </Tooltip>
    )
  }

  return (
    <Tooltip arrow title={tooltip?.title} placement={tooltip?.placement}>
      {/* The label wraps the row so the whole hover-highlighted area toggles the box, not just
          the text and the box itself. */}
      <label htmlFor={checkboxId} className={styles.Checkbox_Background}>
        <input
          type="checkbox"
          id={checkboxId}
          name={label}
          value={label}
          checked={checked}
          disabled={disabled}
          onChange={handleChange}
        />
        <span
          className={dynamicClassName({
            [styles.Checkbox_Label]: true,
            [styles.Checkbox_Label_Disabled]: disabled || false,
          })}
        >
          {label}
        </span>
      </label>
    </Tooltip>
  )
}
